export default __webpack_public_path__ + "static/media/destino-arg-dt.4ffbc2a7.png";